<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ویرایش {{lableText('TaskType')??'نوع وظیفه'}}
                    <button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style overflow-visible">
                <div class="content mb-0">

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : taskTypeModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="taskTypeModel.title" @input="v$.taskTypeModel.title.$touch()" :class="{invalid:v$.taskTypeModel.title.$error}">
                        <p class="text-danger" v-if="v$.taskTypeModel.title.required.$invalid && v$.taskTypeModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>

                    <div class="mb-3">
                        <v-select v-if="OrgJobList!=[] && taskTypeModel.taskTypeId!=0" dir="rtl" label="title" placeholder="پست سازمانی مرتبط" :filterable="false" :searchable="false" multiple chips :options="OrgJobList" :reduce="x=>x.orgJobId" v-model="taskTypeModel.OrgJobIdList">
                            <template slot="option">
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                        <p class="text-danger" v-if="v$.taskTypeModel.OrgJobIdList.required.$invalid && v$.taskTypeModel.OrgJobIdList.$dirty">لطفا پست سازمانی مرتبط را وارد کنید.</p>
                    </div>

                    <button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateTaskType">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>
        <Help-Menu :title="pageTitle" keyEn="TaskList"></Help-Menu>
        <!--<div id="taskTypeHelp" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseVid('video')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">راهنمای نوع وظیفه</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                    <div class="card-bg bg-20"></div>
                </div>
                <div class="d-flex justify-content-center">
                    <video class="responsive-video" controls id="video" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                        <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTaskType.mp4" type="video/mp4">
                    </video>
                </div>
                <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTaskType.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
            </div>
        </div>-->
    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                pageTitle: "",
                taskTypeModel: {
                    code: "",
                    title: null,
                    taskTypeId: 0,
                    userId: 0,
                    strOrgJobId: "",
                    OrgJobIdList: []
                },
            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            OrgJobList() {
                return this.$store.getters.GetOrgJobList;
            },
        },
        created() {
            this.pageTitle = "راهنمای " + (this.lableText('TaskType') ?? 'نوع وظیفه');
            this.GetOrgJobList();
            this.GetTaskTypeItem();

        },
        methods: {
            GetOrgJobList() {
                this.$store.dispatch("GetOrgJobListFromServer");
            },
            GetTaskTypeItem() {
                this.$http.get("Task/GetTaskTypeItem?id=" + this.$route.params.taskTypeId)
                    .then(data => {
                        this.taskTypeModel = data.data;

                        if (data.data.strOrgJobId != null && data.data.strOrgJobId != "") {
                            this.taskTypeModel.OrgJobIdList = [];
                            this.taskTypeModel.OrgJobIdList = data.data.strOrgJobId.split(',');
                            this.taskTypeModel.OrgJobIdList = this.taskTypeModel.OrgJobIdList.map(x => parseInt(x));
                        }
                    });
            },
            CreateTaskType() {
                this.v$.$touch();
                if (!this.v$.$invalid) {
                    this.taskTypeModel.strOrgJobId = this.taskTypeModel.OrgJobIdList.toString();
                    this.$store.dispatch("CreateTaskType", this.taskTypeModel);
                }
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
        },
        validations: {
            taskTypeModel: {
                title: {
                    required
                },
                OrgJobIdList: {
                    required
                },

            }


        },

    };
</script>
